import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_STATICS = "fetchAdminStatics";

// mutation types
export const SET_ADMIN_STATICS = "setAdminStatics";

const state = {
  adminStatics: []
};

const getters = {
  adminStatics(state) {
    return state.adminStatics;
  }
};

const actions = {
  [FETCH_ADMIN_STATICS](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("admin/statics")
        .then(({ data }) => {
          context.commit(SET_ADMIN_STATICS, data);
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ADMIN_STATICS](state, adminStatics) {
    state.adminStatics = adminStatics;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
